import { Grid } from '@mui/material'
import { useLayout } from 'context'
import * as controllers from 'controllers'
import { ClusterShipperDto, ClusterShipperThirdPartyConversionDeliveryDto } from 'dtos'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Step1ThirdPartyConversionDeliveryPhoto from './Step1ThirdPartyConversionDeliveryPhoto'
import ClusterShipperNeedsThirdPartyConversionDeliveryHeroCard from './ClusterShipperNeedsThirdPartyConversionDeliveryHeroCard'
import { enqueueSnackbar } from 'notistack'
import Step2ThirdPartyConversionDeliveryReview from './Step2ThirdPartyConversionDeliveryReview'

export interface ClusterShipperNeedsClusterDeliveredToThirdPartyConversionCompanyPhotoProps {
  thirdPartyConversionDeliveryPhoto: ClusterShipperThirdPartyConversionDeliveryDto
  setThirdPartyConversionDeliveryPhoto: React.Dispatch<React.SetStateAction<ClusterShipperThirdPartyConversionDeliveryDto>>
}

export default function ClusterShipperNeedsClusterDeliveredToThirdPartyConversionCompany() {
  const { clusterShipperGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<ClusterShipperDto>(new ClusterShipperDto())

  const [activeStep, setActiveStep] = useState<number>(0)
  const [thirdPartyConversionDeliveryPhoto, setThirdPartyConversionDeliveryPhoto] =
    useState<ClusterShipperThirdPartyConversionDeliveryDto>(new ClusterShipperThirdPartyConversionDeliveryDto())

  useEffect(() => {
    if (clusterShipperGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getClusterShipper(clusterShipperGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })

      controllers.getClusterShippersThirdPartyConversionDeliveryInformation(clusterShipperGuid).then(response => {
        setThirdPartyConversionDeliveryPhoto(response.value)
      })
    }
  }, [clusterShipperGuid])

  const onBack = () => {
    setActiveStep(prev => Math.max(0, prev - 1))
  }

  const onNext = () => {
    setActiveStep(prev => Math.min(3, prev + 1))
  }

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <ClusterShipperNeedsThirdPartyConversionDeliveryHeroCard clusterShipper={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1ThirdPartyConversionDeliveryPhoto
            onBack={onBack}
            onNext={onNext}
            clusterShipperGuid={clusterShipperGuid}
            clusterShipperDetails={initialValues}
            thirdPartyConversionDeliveryPhoto={thirdPartyConversionDeliveryPhoto}
            setThirdPartyConversionDeliveryPhoto={setThirdPartyConversionDeliveryPhoto}
          />
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid item xs={12}>
          <Step2ThirdPartyConversionDeliveryReview
            onBack={onBack}
            onNext={() => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateClusterShipper(initialValues)
                .then(response => {
                  enqueueSnackbar('Third Pary Conversion Delivery Process Completed Successfully!', { variant: 'success' })
                  setInitialValues(response.value)
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            clusterShipperDetails={initialValues}
            clusterShipperGuid={clusterShipperGuid}
            thirdPartyConversionDeliveryPhoto={thirdPartyConversionDeliveryPhoto}
            setThirdPartyConversionDeliveryPhoto={setThirdPartyConversionDeliveryPhoto}
          />
        </Grid>
      )}
    </Grid>
  )
}
